import React from 'react'
import FeaturedImage from "../../../../styles/img/featured-image.png"
import VolvoLogo from "../../../../styles/img/volvo-logo.png"
import { UiButtonPrimary } from '../form/UiButton'

export default function UiFeaturedCampaignSection(props) {


    return (
        <>
            <div className='sb-featured-campaign-border'>
                <div className='sb-featured-campaign' style={{ backgroundImage: 'url(' + props.backgroundImage + ')', backgroundSize: 'cover', borderRadius: '1rem', backgroundRepeat: 'norepeat' }}>
                    <div className='sb-featured-campaign__border'>
                        <div className='sb-featured-campaign__overlay'>
                            <div className='sb-featured-campaign__image'>
                                <img src={FeaturedImage} />
                            </div>
                            <div className='sb-featured-campaign__content'>
                                <div className='sb-featured-campaign__logo'>
                                    <img src={VolvoLogo} />
                                </div>
                                <div className='sb-featured-campaign__heading'>
                                    <span>Featured Campaign</span>
                                </div>
                                <div className='sb-featured-campaign__featured-heading'>
                                    <h3>{props.featuredTitle}</h3>
                                </div>
                                <div className='sb-featured-campaign__featured-body'>
                                    {props.children}
                                </div>
                                <UiButtonPrimary btnName="Learn more" size="33" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
